



















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { Style } from "@/services/styles/types";
import { WayfinderCSS } from "@/services/wayfinder/types";

@Component
export default class NumbersAndSignsKeyboard extends Vue {
    @Prop() private wayfinderCss!: WayfinderCSS;

    numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
    charsSecondRow = ["@", "/", ".", ",", ":", ";", "!", "#", "%", "^"]
    charsThirdRow = ["&", "*", "(", ")", "-", "[", "]"]
    showNumbers: boolean = true;

    write(char: string) {
        this.$emit("write", char);
    }

    switchKeyboard() {
        this.showNumbers = !this.showNumbers;
        this.$emit("switchKeyboard", this.showNumbers);
    }

    // computed
    get styleModel() {
        return this.wayfinderCss ? this.wayfinderCss : {} as WayfinderCSS;
    }
}
